import { format, parseISO } from "date-fns"

// call_date_time is nullable, so an entry can arrive with no usable date
export const NO_DATE_KEY = "no-date"

export const toTimestamp = (callDateTime: string): number | null => {
  if (!callDateTime) return null
  const timestamp = new Date(callDateTime).getTime()
  return Number.isNaN(timestamp) ? null : timestamp
}

// Keyed on the local date, not UTC, so the group header agrees with the local time on each card
export const toDateKey = (callDateTime: string): string => {
  const timestamp = toTimestamp(callDateTime)
  if (timestamp === null) return NO_DATE_KEY
  return format(new Date(timestamp), "yyyy-MM-dd")
}

// Undated entries sort last whichever direction the user picked
export const compareDateKeys = (a: string, b: string, sortOrder: "asc" | "desc"): number => {
  if (a === NO_DATE_KEY) return 1
  if (b === NO_DATE_KEY) return -1
  return sortOrder === "asc" ? a.localeCompare(b) : b.localeCompare(a)
}

export const formatDateHeader = (dateKey: string, now: Date = new Date()): string => {
  if (dateKey === NO_DATE_KEY) return "No date recorded"

  // parseISO reads "yyyy-MM-dd" as local midnight, matching how the key was built
  const date = parseISO(dateKey)
  const yesterday = new Date(now)
  yesterday.setDate(yesterday.getDate() - 1)

  const startOfDay = (value: Date) =>
    new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime()

  if (startOfDay(date) === startOfDay(now)) return "Today"
  if (startOfDay(date) === startOfDay(yesterday)) return "Yesterday"
  return format(date, "EEEE, MMMM d, yyyy")
}
